module.exports = __webpack_public_path__ + "img/Bottom_Image.cf14baba.jpg";